import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {};

const getters = {};

const actions = {
  async getUserByEmail({ commit }, data) {
    return await API.get(
      `${environment.apiUri}${route.User}?Email=${localStorage.getItem(
        "email"
      )}`
    );
  },
  async getUserDataByEmail({ commit }, data) {
    return await API.get(
      `${environment.apiUri}${route.User}?Email=${data.email}`
    );
  },
  async getByUserName({ commit }, data) {
    return await API.get(
      `${environment.apiUri}${route.User}?Name=${data.name}&Limit=5&Offset=0&Sort=+ID`
    );
  },
  async getUsersByPagination({ commit }, data) {
    if (!(data.name.length > 0)) {
      return await API.get(
        `${environment.apiUri}${route.User}?Limit=5&Offset=${data.offset}&Sort=+ID`
      );
    } else {
      return await API.get(
        `${environment.apiUri}${route.User}?Name=${data.name}&Limit=5&Offset=${data.offset}&Sort=+ID`
      );
    }
  },
  async putDisableUser({ commit }, data) {
    return await API.put(
      `${environment.apiUri}${route.DisableUser}?email=${data.email}&disable=${data.disable}`
    );
  },
  async putRemoveRole({ commit }, data) {
    return await API.put(
      `${environment.apiUri}${route.RemoveRole}?email=${data.email}&role=${data.roles}
      `
    );
  },
  //Workaround
  async adduserRole({ commit }, data) {
    return await API.post(
      `${environment.apiUri}${route.AddUserRole}?email=${data.email}&roles=${data.roles}`
    );
  },
  getListUserRoleByPagination({ commit }, data) {
    if (!(data.name.length > 0)) {
      return API.get(
        `${environment.apiUri}${route.GetListUserRole}?email=${data.email}&rolesAssociates=${data.rolesAssociates}&Limit=${data.limit}&Offset=${data.offset}&Sort=+ID`
      );
    } else {
      return API.get(
        `${environment.apiUri}${route.GetListUserRole}?email=${data.email}&rolesAssociates=${data.rolesAssociates}&Name=${data.name}&Limit=${data.limit}&Offset=${data.offset}&Sort=+ID`
      );
    }
  },
  async registerUser({ commit }, data) {
    return await API.post(`${environment.apiUri}${route.RegisterUser}`, data);
  },
  async checkLogin({ commit }, data) {
  return await API.get(
    `${environment.apiUri}${route.CheckLogin}?email=${data.email}`
  );
},
};
const mutations = {};

export default {
  state,
  actions,
  getters,
  mutations,
};
